<template>
    <div class="community-section">
        <div class="cards-row">
            <div v-for="obj in articles" :key="obj.id" class="card-article" @click="goToArticle(obj.id)">
                <div class="author-container">
                    <img :src="obj.authorImageUrl" @error="handleImageError" class="image-author">

                    <div class="author-info">
                        <h4 class="author-name">{{ obj.authorName }}, {{ obj.specialtyAuthor }}</h4>

                        <h3 class="title-news">{{ obj.title }}</h3>

                        <div class="articles-data">Artigos <span>{{ formatDate(obj.contentDate) }}</span></div>

                        <p class="content-preview">
                            {{ obj.coverCallout }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import fallbackImage from '@/assets/images/image-error-no-legend.svg';
import RoutesPaths from '../../../router/router-structure/routes-paths';

export default {
    props: {
        articles: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    methods: {
        handleImageError(event) {
            event.target.src = fallbackImage;
        },
        formatDate(data) {
            if (!data) return '';

            const dateObj = new Date(data);
            return dateObj.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
        },
        goToArticle(id) {
            this.$router.push({
                path: RoutesPaths.connection.preview(id)
            });
        }
    },
}

</script>

<style scoped>
.author-info {
    font-family: "Trebuchet MS", sans-serif;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
}

.card-article {
    flex: 1;
    padding: 1rem;
    border-radius: 8px;
    border: 1px solid #DFDFDF;
    background: #F4F6F6;
    margin-bottom: 1rem;
    cursor: pointer;
}

.author-container {
    display: flex;
    align-items: center;
    gap: 20px;
}

.image-author {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.author-name {
    color: #007A4A;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    margin: 0;
}

.title-news {
    color: #212529;
    font-size: 18px;
    font-weight: 700;
    margin-top: 8px;
}

.meta-data {
    display: flex;
    gap: 12px;
    font-size: 12px;
    margin: 8px 0;
}

.date {
    color: #6C757D;
    font-size: 14px;
}

.content-preview {
    color: #495057;
    font-size: 16px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
}

.cards-row {
    display: flex;
    gap: 16px;
    width: 100%;
    margin-bottom: 20px;
}

.community-section {
    width: 100%;
    font-family: "Trebuchet MS", sans-serif;
}

.section-title {
    color: #3D3F40;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 30px;
    margin-top: 0;
}

.articles-data {
    margin: 8px 0;
    font-size: 12px !important;
    display: flex;
    align-items: center;
    gap: 16px;
}

.articles-data span {
    font-family: "Trebuchet MS";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    color: #7A7E83 !important;
}
</style>